import { render, staticRenderFns } from "./Area_listPicture.vue?vue&type=template&id=62b0db7b&scoped=true&"
import script from "./Area_listPicture.vue?vue&type=script&lang=js&"
export * from "./Area_listPicture.vue?vue&type=script&lang=js&"
import style0 from "./Area_listPicture.vue?vue&type=style&index=0&id=62b0db7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0db7b",
  null
  
)

export default component.exports